import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetInvestigationSummaryRPC } from "./getInvestigationSummaryRPC";

export class GetInvestigationSummaryRPCClientImpl extends GetInvestigationSummaryRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetInvestigationSummaryRPC.Request): Promise<LeoRPCResult<GetInvestigationSummaryRPC.Response, GetInvestigationSummaryRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "email-cycle/GetInvestigationSummary",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetInvestigationSummaryRPC.ResponseDTO,
      GetInvestigationSummaryRPC.Errors.ErrorsDTO,
      GetInvestigationSummaryRPC.Response,
      GetInvestigationSummaryRPC.Errors.Errors
    >(
      response,
      "email-cycle/GetInvestigationSummary",
      GetInvestigationSummaryRPC.Response.fromDTO,
      GetInvestigationSummaryRPC.Errors.fromDTO
    );
  }
}
